import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import {defineMessages, injectIntl, FormattedMessage, intlShape} from 'react-intl';
import ReactModal from 'react-modal';

import Box from '../box/box.jsx';
import styles from '../telemetry-modal/telemetry-modal.css';

const messages = defineMessages({
    label: {
        id: 'gui.mDesigner.label',
        defaultMessage: 'Alerta: M_designer'
    },
    title: {
        id: 'gui.mDesigner.title',
        defaultMessage: 'Alerta: M_designer'
    },
    body: {
        id: 'gui.mDesigner.body',
        defaultMessage: 'Para acessar o kit externo, pressione ou ative o link abaixo para baixar.'
    },
    download: {
        id: 'gui.mDesigner.download',
        defaultMessage: 'Baixar OpenLink'
    },
    closeButton: {
        id: 'gui.mDesigner.close',
        defaultMessage: 'Fechar'
    }
});

class MDesignerModal extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleCancel',
            'handleDownload'
        ]);
        this.state = {};
    }

    handleCancel () {
        if (this.props.onRequestClose) this.props.onRequestClose();
    }

    handleDownload () {
        if (this.props.downloadUrl) {
            window.open(this.props.downloadUrl, '_blank');
        }
    }

    render () {
        const {isRtl, intl} = this.props;
        return (
            <ReactModal
                isOpen
                className={styles.modalContent}
                contentLabel={intl.formatMessage(messages.label)}
                overlayClassName={styles.modalOverlay}
                onRequestClose={this.handleCancel}
            >
                <div dir={isRtl ? 'rtl' : 'ltr'}>
                    <Box className={styles.body}>
                        <div>
                            <strong><FormattedMessage {...messages.title} /></strong>
                        </div>
                        <div style={{marginTop: '8px', marginBottom: '8px'}}>
                            <FormattedMessage {...messages.body} />
                        </div>
                        <div style={{marginBottom: '8px'}}>
                            <a
                                href={this.props.downloadUrl}
                                target={'_blank'}
                                rel={'noopener noreferrer'}
                            >
                                {this.props.downloadUrl}
                            </a>
                        </div>
                        <Box className={styles.buttonRow}>
                            <button
                                className={styles.optIn}
                                onClick={this.handleDownload}
                            >
                                <FormattedMessage {...messages.download} />
                            </button>
                            <button
                                className={styles.optIn}
                                onClick={this.handleCancel}
                            >
                                <FormattedMessage {...messages.closeButton} />
                            </button>
                        </Box>
                    </Box>
                </div>
            </ReactModal>
        );
    }
}

MDesignerModal.propTypes = {
    isRtl: PropTypes.bool,
    onRequestClose: PropTypes.func,
    downloadUrl: PropTypes.string,
    intl: intlShape
};

MDesignerModal.defaultProps = {
    downloadUrl: 'https://drive.google.com/file/d/1ppYT9TktjuUzdKCdxVsVUaVOXAv2T3TU/view?usp=sharing'
};

export default injectIntl(MDesignerModal);
